import React from "react"

export default function Details() {
  return (
    <div className="detaisl" id="Features">
      <img
        src="/images/main-tag.webp"
        alt=""
        className="w-[25vw] rotate-left-right "
      />
    </div>
  )
}
